var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 56,
    viewBox: "0 0 32 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.801758 46.3925C0.801758 45.0523 1.33414 43.767 2.28178 42.8194C3.22942 41.8717 4.51469 41.3394 5.85486 41.3394H26.0673C27.4074 41.3394 28.6927 41.8717 29.6403 42.8194C30.588 43.767 31.1204 45.0523 31.1204 46.3925V49.7612C31.1204 51.1014 30.588 52.3866 29.6403 53.3343C28.6927 54.2819 27.4074 54.8143 26.0673 54.8143H5.85486C4.51469 54.8143 3.22942 54.2819 2.28178 53.3343C1.33414 52.3866 0.801758 51.1014 0.801758 49.7612V46.3925Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53857 48.0767V48.0932Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53857 48.0767V48.0932",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2769 48.0767H24.3831Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2769 48.0767H24.3831",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.801758 32.9174C0.801758 31.5772 1.33414 30.2919 2.28178 29.3443C3.22942 28.3966 4.51469 27.8643 5.85486 27.8643H26.0673C27.4074 27.8643 28.6927 28.3966 29.6403 29.3443C30.588 30.2919 31.1204 31.5772 31.1204 32.9174V36.2861C31.1204 37.6263 30.588 38.9115 29.6403 39.8592C28.6927 40.8068 27.4074 41.3392 26.0673 41.3392H5.85486C4.51469 41.3392 3.22942 40.8068 2.28178 39.8592C1.33414 38.9115 0.801758 37.6263 0.801758 36.2861V32.9174Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53906 34.6016V34.6181Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53906 34.6016V34.6181",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2769 34.6016H24.3831Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2769 34.6016H24.3831",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.801758 19.4423C0.801758 18.1021 1.33414 16.8168 2.28178 15.8692C3.22942 14.9215 4.51469 14.3892 5.85486 14.3892H26.0673C27.4074 14.3892 28.6927 14.9215 29.6403 15.8692C30.588 16.8168 31.1204 18.1021 31.1204 19.4423V22.811C31.1204 24.1512 30.588 25.4364 29.6403 26.3841C28.6927 27.3317 27.4074 27.8641 26.0673 27.8641H5.85486C4.51469 27.8641 3.22942 27.3317 2.28178 26.3841C1.33414 25.4364 0.801758 24.1512 0.801758 22.811V19.4423Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53906 21.1265V21.143Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53906 21.1265V21.143",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2769 21.1265H24.3831Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2769 21.1265H24.3831",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0.801758 5.96765C0.801758 4.62749 1.33414 3.34221 2.28178 2.39457C3.22942 1.44693 4.51469 0.914551 5.85486 0.914551H26.0673C27.4074 0.914551 28.6927 1.44693 29.6403 2.39457C30.588 3.34221 31.1204 4.62749 31.1204 5.96765V9.33638C31.1204 10.6766 30.588 11.9618 29.6403 12.9095C28.6927 13.8571 27.4074 14.3895 26.0673 14.3895H5.85486C4.51469 14.3895 3.22942 13.8571 2.28178 12.9095C1.33414 11.9618 0.801758 10.6766 0.801758 9.33638V5.96765Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53906 7.65186V7.6684Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53906 7.65186V7.6684",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2769 7.65186H24.3831Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2769 7.65186H24.3831",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle3);
export default __webpack_public_path__ + "static/media/single3.d40b67dcaeebdea4c6da392a8ff12bad.svg";
export { ForwardRef as ReactComponent };